import * as log from 'loglevel';
import {game} from "../../GameCore";
import {forEach, times, random, concat, pull, sample, find, head, get, some} from 'lodash';
import {gameConfig} from '../../config/GameConfig';
import {levelGroup} from '../Level';
import {getGameManager} from '../../GameManager';
import {gameState} from '../../config/GameState';
import {playSound} from '../../audio/AudioManager';
import {addPowerupGoodParticles, addPowerupBadParticles} from '../../particles/ParticleManager';
import {obstacleSprites} from '../ground/Obstacles';
import {recyclingPickupSprites} from '../platforms/RecyclingPickups';

export var powerUpSprites: Phaser.Sprite[];

var timer: Phaser.Timer;



/**
 * create a pool of power up sprites
 */
export function createPowerUps()
{
    var sprite: Phaser.Sprite;

    powerUpSprites = times(4, (i: number) =>
    {
        //  create a sprite

        sprite = game.add.sprite(-500, -500, 'sprites', 'speed-up');

        //  enable physics on the sprite

        game.physics.arcade.enable(sprite);

        //  set sprite physics properties

        sprite.body.allowGravity = false;
        sprite.body.customSeparateX = true;
        sprite.body.customSeparateY = true;
        sprite.alive = false;
        sprite.anchor = new Phaser.Point(0.5, 0.5);

        levelGroup.addChild(sprite);


        //  add sprite animations

        var tweenA: Phaser.Tween,
            tweenB: Phaser.Tween,
            tweenC: Phaser.Tween,
            tweenD: Phaser.Tween;

        tweenA = game.add.tween(sprite).to( { alpha: 0.75 }, 500, Phaser.Easing.Quadratic.InOut);
        tweenB = game.add.tween(sprite).to( { alpha: 1 }, 500, Phaser.Easing.Quadratic.InOut);

        tweenC = game.add.tween(sprite.scale).to( { x: 1.1, y: 1.1 }, 500, Phaser.Easing.Quadratic.InOut);
        tweenD = game.add.tween(sprite.scale).to( { x: 0.9, y: 0.9 }, 500, Phaser.Easing.Quadratic.InOut);

        tweenA.chain(tweenB);
        tweenC.chain(tweenD);

        tweenB.onComplete.add(() =>
        {
            tweenA.start();
        }, this);

        tweenD.onComplete.add(() =>
        {
            tweenC.start();
        }, this);

        (<any>sprite).tweens = [tweenA, tweenB, tweenC, tweenD];

        //  return the sprite

        return sprite;
    });
}





/**
 * reset and remove all powerups
 */
export function resetPowerUps()
{
    //  stop the current timer

    if (timer) timer.stop();

    //  reset positions for all power ups

    forEach(powerUpSprites, (sprite: Phaser.Sprite) =>
    {
        sprite.reset(-400, -400);
    });

    //  restart power up timer

    timer = game.time.create(false);

    //  queue a power up

    queuePowerUp();

    //  start the timer

    timer.start();
}



/**
 * init and place a power up in the level
 */
export function queuePowerUp()
{
    var nextPowerUpDuration: number;

    //  don't create platforms when we're outside

    if (gameState.level.isOutside) return;

    //  add a power up to the game

    //addPowerUp();

    //  restart the timer for the next power-up

    nextPowerUpDuration = 1000 + Math.random() * 1500;

    timer.add(nextPowerUpDuration, queuePowerUp);
}


/**
 * add a new power up to the stage
 */
export function addPowerUp()
{
    var sprite: any,
        powerUpIndex: number,
        powerUp: any;

    //  choose a power-up at random

    powerUpIndex = random(0, 5, false);

    //  choose a power-up at random

    powerUp = gameConfig.powerUps[powerUpIndex];

    //  get the first available power-up sprite

    sprite = findFirstDead();

    //  if no sprite is available, stop here

    if ( ! sprite) return;

    //  make negative power-ups more rare

    //log.debug('creating powerup:', powerUpIndex, 1 / (powerUpIndex || 1))

    if (Math.random() > 1 / (powerUpIndex || 1)) return;


    //  reset and place the sprite

    sprite.frameName = powerUp.frameName;
    sprite['powerUpIndex'] = powerUpIndex;

    var x: number,
        y: number,
        ox: number,
        oy: number,
        spriteWidth: number,
        spriteHeight: number;

    x = game.world.width + (game.world.width * Math.random()) - levelGroup.x;
    y = getPowerUpY(powerUpIndex);

    //spriteWidth = sprite.body.width;
    //spriteHeight = sprite.body.height;
    spriteWidth = 100;
    spriteHeight = 100;
    ox = 150;
    oy = 200;


    //console.log('placing power-up')

    if (some(obstacleSprites, (obstacle: Phaser.Sprite) =>
        {

            //console.log('obstalce', x, y, ' === ', obstacle.x, obstacle.y)


            if (x + spriteWidth < obstacle.x - ox || x > obstacle.x + ox) return false;
            if (y + spriteHeight < obstacle.y - oy || y > obstacle.y + oy) return false;

            //console.log('colliding!')

            return true;
        })) return;

    //console.log('placing power-up')


    if (some(recyclingPickupSprites, (obstacle: Phaser.Sprite) =>
        {
            //console.log('recyling', x, y, ' === ', obstacle.x, obstacle.y)

            if (x + spriteWidth < obstacle.x - ox || x > obstacle.x + ox) return false;
            if (y + spriteHeight < obstacle.y - oy || y > obstacle.y + oy) return false;

            //console.log('colliding!')

            return true;
        })) return;


    sprite.reset(x, y);

    //  start the sprite animation loop

    (<Phaser.Tween>get(sprite, 'tweens[0]')).start();
    (<Phaser.Tween>get(sprite, 'tweens[2]')).start();
}


/**
 * find the first dead power-up sprite to re-use
 */
function findFirstDead()
{
    return find(powerUpSprites, { alive: false });
}



/**
 * start a looping timer to add power-ups to the game
 */
function startPowerUpTimer()
{

}


/**
 * collect a power up and activate its power
 * @param sprite
 */
export function collectPowerUp(sprite: any)
{
    var powerUp: any;

    //  active the power-up#s special power

    powerUp = find(gameConfig.powerUps, { 'frameName': sprite.frameName });

    //  add power-up modifiers

    if (powerUp.scoreModifier)
    {
        //  modify score

        getGameManager().incrementScore(powerUp.scoreModifier);

        //  display power-up effect to the user

        getGameManager().visibleBonus(powerUp.scoreModifier + ' points');
    }

    if (powerUp.speedModifier)
    {
        //  modify speed

        gameState.player.powerupMultiplier = powerUp.speedModifier || 1;

        game.add.tween(gameState.player).to({ powerupMultiplier: 1 }, 250, null, true, 3000);
    }

    if (powerUp.timeModifier)
    {
        //  modify time

        getGameManager().incrementTimeRemaining(powerUp.timeModifier || 0);

        //  display power-up effect to the user

        getGameManager().visibleBonus(powerUp.timeModifier + ' seconds');
    }


    //  kill the sprite

    sprite.kill();

    //  stop animation

    killSignTweens(sprite);

    //  play an audio clip

    switch (sprite['powerUpIndex'])
    {
        case 0:

            playSound('time-up');

            break;

        case 1:

            playSound('speed-up');

            break;

        case 2:

            playSound('points-up');

            break;

        default:

            playSound('bad-power-up');

            break;
    }

    if (sprite['powerUpIndex'] <= 2)
    {
        addPowerupGoodParticles(sprite.x, sprite.y);
    }
    else
    {
        addPowerupBadParticles(sprite.x, sprite.y);
    }
}


/**
 * get the y position for a platform with a given index
 * @param level
 */
function getPowerUpY(level: number) : number
{
    //level = Math.min(Math.max(level, 0), 5);

    return gameConfig.tileWidth * sample([0.5, 1, 2, 4, 5, 7]) + gameConfig.tileWidth * 0.5;
}


/**
 * check whether the first power-up has scrolled off the page
 */
export function updatePowerUps()
{
    var sprite: Phaser.Sprite;

    //  get the first tile in the list

    //sprite = head(powerUpSprites);

    forEach(powerUpSprites, (sprite: Phaser.Sprite, i: number) =>
    {
        //  if the sprite is still in play stop here

        if (sprite.body.x > gameConfig.tileWidth * -1) return;

        //  if it's scrolled off the screen, remove it from play

        sprite.kill();

        //  stop animation

        killSignTweens(sprite);
    })
}


/**
 * stop the sign bouncing when it leaves the stage
 * @param sprite
 */
function killSignTweens(sprite: Phaser.Sprite)
{
    //forEach(get(sprite, 'tweens'), (tween: Phaser.Tween) =>
    //{
    //    tween.stop();
    //});
}


// WEBPACK FOOTER //
// ./src/ts/game/level/power-ups/PowerUps.ts